import React from 'react';
import { MenuListItem, MenuSection, MenuList } from '@atlaskit/navigation-system';

export const RenderMostRecentProjectSection = ({
	projectItem,
}: {
	projectItem: React.JSX.Element | null;
}) => {
	return (
		!!projectItem && (
			<MenuListItem testId="navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.ui.content.most-recent-project-section.most-recent-project-section">
				<MenuSection>
					{/* We need to wrap the projectItem in a MenuList since projectItem has role 'listitem'
					which needs a parent with role 'list' */}
					<MenuList>{projectItem}</MenuList>
				</MenuSection>
			</MenuListItem>
		)
	);
};
